import React, { Component } from "react";
import { withTranslation } from "react-i18next";

class SuccessMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isThirdParty: this.props.isThirdParty,
    };
  }

  navigateToUrl = (event) => {
    if(this.state.isThirdParty){
      window.location.href = this.props.messageDetails.loginUrl;
    } else {
      window.location.href = this.props.messageDetails.returnUrl;
    }
  }

  render() {
    const { t } = this.props;

    return (
      <div>
        <div className="loginIntroTextContainer">
          <h2>
            <i className="fas fa-check-circle"></i>{" "}
            {t(this.props.messageDetails.headerMsg)}{" "}
          </h2>
          <p className="headerdescription">
            {t(this.props.messageDetails.descriptionMsg)}{" "}
          </p>
        </div>
        <button
          type="button"
          className="btn min_outlin_btn active px-4"
          onClick={(e) => this.navigateToUrl(e)}
        >
          {t(this.props.messageDetails.btnLabel)}{" "}
          <i className="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    );
  }
}
export default withTranslation()(SuccessMessage);
